import { ChangeDetectionStrategy, Component, Input, output, input } from '@angular/core';

import type { GuardedFeature } from '@core/feature-guard-legacy';
import { FeatureGuardMode, FeatureGuardDropdownItemComponent } from '@core/feature-guard-legacy';
import type { IconName } from '@core/user-interface-legacy';
import {
  BadgeComponent,
  HeadingComponent,
  IconComponent,
  DropdownItemComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-redactor-inserts-dropdown-item',
  templateUrl: 'redactor-inserts-dropdown-item.component.html',
  styleUrls: ['./redactor-inserts-dropdown-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FeatureGuardDropdownItemComponent,
    DropdownItemComponent,
    IconComponent,
    HeadingComponent,
    BadgeComponent,
  ],
})
export class RedactorInsertsDropdownItemComponent {
  public readonly iconName = input<IconName>(undefined!);
  public readonly heading = input<string>(undefined!);
  public readonly subheading = input<string>(undefined!);
  public readonly selected = input<boolean>(undefined!);
  public readonly featureGuard = input<GuardedFeature>(undefined!);
  @Input() public badgeText?: string;

  public stepInside = output<MouseEvent>();

  public featureGuardMode: typeof FeatureGuardMode = FeatureGuardMode;
}
